﻿
$(document).ready(function () {

    $("#hamburger-menu-button").on("click",
        function () {
            setTimeout(function () {
                $("#hamburger-menu-button").toggleClass("hamburger-menu-change");
                $("#menu-dropdown-content-mobile").toggleClass("active-hamburger");
                $("#logo-image").toggleClass("default-logo");
            },
                100);
        });

    $("#hamburger-desktop-button").on("click",
        function () {
            setTimeout(function () {
                $("#hamburger-desktop-button").toggleClass("hamburger-menu-change");
                $("#menu-dropdown-content-desktop").toggleClass("active-hamburger");
                $("body").toggleClass("overflow-hidden");
                $("#logo-image").toggleClass("default-logo");

            },
                100);
        });


});


$(".menu-nav-dropdown").click(
    function () {
        var self = $(this).parent();
        self.siblings().find(".menu-item").removeClass("active-menu-item");
        self.siblings().find(".dropdown-content").slideUp(0.5);
        self.siblings().find('.dropdown-language').slideUp(0.5);
        self.siblings().find(".dropdown-button").removeClass("active-dropdown");
        self.find('.dropdown-button').toggleClass("active-dropdown");
        self.find('.dropdown-content').slideToggle();
        $(this).addClass("active-menu-item");
    }
);



$(".boat-model-toggle").click(
    function () {
        var self = $(this).parent();
        $("#menu-dropdown-content-desktop").scrollTop(0);
        self.find('.dropdown-content.models').slideToggle();
        $(this).addClass("active-menu-item");
    }
);

$(".boat-toggle").click(
    function () {
        var self = $(this).parent();
        $("#menu-dropdown-content-desktop").scrollTop(0);
        self.find('.dropdown-content-boat').slideToggle();
    }
);


$("#close_boat_model_menu").click(
    function () {
        var self = $(this).parent().parent();
        self.slideToggle();
    });

$(".close_boat_menu").click(
    function () {
        $(".dropdown-content-boat").slideUp();
    });


$('html').click(function (event) {
    var e = $(event.target);
    if (e.parents(".dropdown-content").length < 1 && e.next(".dropdown-content").length < 1) {
        $(".dropdown-content").slideUp(400);

        $(".menu-item.active-menu-item").removeClass("active-menu-item");
    }
    if (!$(event.target).closest(".language-picker").length) {
        $(".dropdown-language").slideUp(400);
    }
});

$(document).ready(function () {
    $(window).scroll(function () {
        if ($(document).scrollTop() > 50) {
            $("body").addClass("header-sticky");
        } else {
            $("body").removeClass("header-sticky");
        }
    });
});

$(document).ready(function () {
    $(".boat-model-card").each(function () {

        $(this).on("click",
            function () {
                var boatModelRowId = $(this).attr("id");
                var boatRowFullId = boatModelRowId + "-boat-row";
                $("#" + boatRowFullId).slideToggle();

                $(".boat-model-card").each(function () {

                    // Skip the ones that just got clicked
                    if ($(this).attr("id") === boatModelRowId) {
                        return;
                    }

                    // Hide all others
                    var boatModelRowIdInner = $(this).attr("id");
                    var boatRowFullIdInner = boatModelRowIdInner + "-boat-row";
                    if ($("#" + boatRowFullIdInner).is(":visible")) {
                        $("#" + boatRowFullIdInner).slideToggle();
                    }
                });
            });
    });

    // Hide when click on x-icon
    $(".boats-close-button").each(function () {

        var wrappingDivId = $(this).parent().parent().parent().attr("id");
        $(this).on("click",
            function () {
                $("#" + wrappingDivId).slideToggle();
            });
    });
});